module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_027.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_027.png
// module id = 2374
// module chunks = 5